import { ROUTES, type Route } from './contracts';

export function resolveRoute(pathname: string): Route | null {
  const normalized = pathname === '/' ? '/' : pathname.replace(/\/+$/, '');
  return (ROUTES as readonly string[]).includes(normalized) ? normalized as Route : null;
}

export const pageLoaders = {
  '/': () => import('../pages/snap/index'),
  '/rift': () => import('../pages/rift/index'),
  '/chaos': () => import('../pages/chaos/index'),
} satisfies Record<Route, () => Promise<{ default: import('./contracts').PageModule }>>;
